const DEFAULT_PROD_API_BASE_URL = 'https://return-attribution-c87301303521.herokuapp.com';

const rawEnvBaseUrl = process.env.REACT_APP_API_BASE_URL;

const resolvedBaseUrl =
  rawEnvBaseUrl !== undefined
    ? rawEnvBaseUrl
    : (process.env.NODE_ENV === 'development' ? '' : DEFAULT_PROD_API_BASE_URL);

export const API_BASE_URL = resolvedBaseUrl.replace(/\/$/, '');
